module.exports = __webpack_public_path__ + "img/E-WEB-Goal-08.6d678190.png";